import { render } from "./Invitation.vue?vue&type=template&id=6d4cd4db&scoped=true"
import script from "./Invitation.vue?vue&type=script&lang=js"
export * from "./Invitation.vue?vue&type=script&lang=js"

import "./Invitation.vue?vue&type=style&index=0&id=6d4cd4db&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4cd4db"]])

export default __exports__